// extracted by mini-css-extract-plugin
export default {"wrap":"VideoPlayer_wrap__xjo6u","overlay":"VideoPlayer_overlay__PkvQ2"};